import { useRef, useEffect } from "react";
import "../../App.css";

function VnirRgbCanvas(props) {
	const canvasRef = useRef(null);

	const draw = (canvas, ctx, x1, y1, x2, y2) => {
		ctx.strokeStyle = "green";
		ctx.lineWidth = 2;
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.strokeRect(x1, y1, x2, y2);
	};

	useEffect(() => {
		const canvas = canvasRef.current;
		const context = canvas.getContext("2d");

		draw(
			canvas,
			context,
			props.x1,
			props.y1,
			props.x2 - props.x1,
			props.y2 - props.y1
		);

		// eslint-disable-next-line
	}, [props.x1, props.x2, props.y1, props.y2]);

	return (
		<div
			id="canvas-wrapper"
			className={props.type}
			style={{ width: props.width, height: props.height }}
		>
      {props.img ?
        <img
          src={props.img}
          alt="Vnir RGB"
          className="imageScan"
          width={props.width}
          height={props.height}
        />
      : "Loading..."}
			<canvas
				className="canvas"
				id="vnir-rgb-canvas"
				ref={canvasRef}
				width={props.width}
				height={props.height}
			/>
		</div>
	);
}

export default VnirRgbCanvas;
